<template>
  <div class="webdatalist">
    <f7-list media-list id="draft-list">
      <li class="swipeout" v-for="draft in filteredDrafts" @swipeout:deleted="deleteDraft(draft.idDraft)">
        <div class="swipeout-content item-content draftTaphold boxRequest"
        :data-item="draft.idDraft"
        :data-complete="draft.isComplete"
        @click="createPayments(draft)">
          <div class="item-media">
            <i class="icon list-icon icon-edit"></i>
          </div>
          <div class="item-inner">
            <div class="item-title-row">
              <table width="100%">
                <tr>
                  <td class="requestTitle">
                      {{draft.draftName}}
                  </td>
                  <td width="60%">
                    <div class="showLargeScreenOnly">
                    <div class="item-subtitle streammindBlueFont" v-if="draft.isComplete === '1'">{{getLabelStatus(draft.isComplete)}}</div>
                    <div class="item-subtitle redFont" v-else-if="draft.isComplete === '0'">{{getLabelStatus(draft.isComplete)}}</div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            <div class="item-subtitle streammindBlueFont showSmallScreenOnly" v-if="draft.isComplete === '1'">{{getLabelStatus(draft.isComplete)}}</div>
            <div class="item-subtitle redFont showSmallScreenOnly" v-else-if="draft.isComplete === '0'">{{getLabelStatus(draft.isComplete)}}</div>
          </div>
        </div>
        <div class="swipeout-actions-right">
          <a href="#" class="swipeout-delete"
          data-confirm="You won't be able to recover this draft from MoneyRoad"
          data-confirm-title="Remove?"
          data-close-on-cancel="true">
            Delete
          </a>
        </div>
      </li>
    </f7-list>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'DraftList',
  props: ['drafts', 'filterBy'],
  computed: {
    filteredDrafts () {
      let that = this
      let result = []
      if (this.filterBy) {
        for (var k in that.drafts) {
          if (that.drafts[k].draftName.toLowerCase().includes(this.filterBy.toLowerCase())) {
            result.push(that.drafts[k])
          }
        }
        return result
      }
      return this.drafts
    }
  },
  methods: {
    createPayments (draft) {
      let that = this
      that.$engine.settings.set({preChargedDraft: draft})
      loadPage(that, {url: '/payments/draft/edit/'})
    },
    getLabelStatus (isComplete) {
      if (isComplete === 1) {
        return 'Ready to send'
      } else {
        return 'Need to be completed'
      }
    },
    deleteDraft (idDraft) {
      let that = this
      that.$engine.drafts
      .del(idDraft)
      .then(() => {
        that.$f7.alert('', 'Draft Removed')
      })
      .catch(err => {
        errorMessageAlert(err, that)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// CMDraftList.vue?1fd6d05e